import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React, { useContext } from "react";
import { Link, useParams } from "react-router-dom";

import { zinc } from "@/components/DriverView/ui/colors";
import PanelHeader from "@/components/DriverView/ui/PanelHeader";
import MenuButton from "@/components/MenuButton";
import { ampli } from "@/config";
import { useReactiveSelectQuery } from "@/models/hooks/useReactiveSelectQuery";
import { fetchFeedsForAccountQuery } from "@/models/repositories";
import { WorkspaceContext } from "@/models/StateProviders/workspaceProvider";

export default function FeedAliasHeader({
  aliasAccount,
}: {
  aliasAccount: { id: string; name: string; alias: string; title: string };
}) {
  const { feedId, workspaceMembershipId } = useParams();
  const { currentWorkspaceId } = useContext(WorkspaceContext);
  const [isDropdownOpen, setIsDropdownOpen] = React.useState(false);

  const userChannelList =
    useReactiveSelectQuery(
      fetchFeedsForAccountQuery,
      [aliasAccount.id, currentWorkspaceId],
      "NewFeedAliasHeader:fetchFeedsForAccountQuery",
    ) ?? [];

  const hasMoreThanOneChannel = userChannelList.length > 1;

  return (
    <Box key={aliasAccount.id}>
      <PanelHeader>
        <Box sx={{ flexGrow: 1, display: "flex", alignItems: "center", gap: 1 }}>
          <MenuButton
            key={feedId}
            position="left"
            element={
              <Box
                sx={{
                  textAlign: "left",
                  py: 0.5,
                  borderRadius: 1,
                  px: 1,
                  ...(hasMoreThanOneChannel && {
                    "&:hover": { bgcolor: zinc[700] },
                    cursor: "pointer",
                  }),
                }}
              >
                <Typography sx={{ fontSize: "1.25rem", fontWeight: 700, mb: "-4px", color: "white" }}>
                  {aliasAccount.name}
                </Typography>
                <Box sx={{ fontSize: "0.875rem", color: zinc[300], display: "flex", alignItems: "center", gap: 0.5 }}>
                  <span>{aliasAccount.alias}</span>
                  {hasMoreThanOneChannel && (
                    <>
                      {!isDropdownOpen ? (
                        <KeyboardArrowDownIcon sx={{ fontSize: "12px" }} />
                      ) : (
                        <KeyboardArrowUpIcon sx={{ fontSize: "12px" }} />
                      )}
                    </>
                  )}
                </Box>
              </Box>
            }
            openState={(value) => setIsDropdownOpen(() => value)}
          >
            {userChannelList?.length > 1 && (
              <Box component="ul" sx={{ py: 1, listStyle: "none", m: 0, px: 0 }}>
                {userChannelList.map((channel) => (
                  <Box component="li" key={channel.id} sx={{ mb: 0.5 }}>
                    <Link
                      style={{
                        display: "block",
                        padding: "8px 16px",
                        textAlign: "left",
                        fontSize: "0.875rem",
                        textDecoration: "none",
                        color: feedId === channel.id ? zinc[400] : "white",
                        backgroundColor: feedId === channel.id ? zinc[700] : "transparent",
                      }}
                      onMouseEnter={(e) => {
                        if (feedId !== channel.id) e.currentTarget.style.backgroundColor = zinc[700];
                      }}
                      onMouseLeave={(e) => {
                        if (feedId !== channel.id) e.currentTarget.style.backgroundColor = "transparent";
                      }}
                      onClick={() => {
                        if (feedId !== channel.id) ampli.switchChannel();
                      }}
                      to={`/workspaces/${channel.workspaceId}/drivers/${workspaceMembershipId}/channel/${channel.id}`}
                    >
                      {channel.alias}
                    </Link>
                  </Box>
                ))}
              </Box>
            )}
          </MenuButton>
        </Box>
      </PanelHeader>
    </Box>
  );
}
